const avatars: Record<number, string> = {
  1: "assets/images/avatars/avatar-1.jpg",
  2: "assets/images/avatars/avatar-2.jpg",
  3: "assets/images/avatars/avatar-3.jpg",
  4: "assets/images/avatars/avatar-4.jpg",
  5: "assets/images/avatars/avatar-5.jpg",
  6: "assets/images/avatars/avatar-6.jpg",
  7: "assets/images/avatars/avatar-7.jpg",
  8: "assets/images/avatars/avatar-8.jpg",
  9: "assets/images/avatars/avatar-9.jpg",
  10: "assets/images/avatars/avatar-10.jpg",
  11: "assets/images/avatars/avatar-11.jpg",
  12: "assets/images/avatars/avatar-12.jpg",
  13: "assets/images/avatars/avatar-13.jpg",
  14: "assets/images/avatars/avatar-14.jpg",
  15: "assets/images/avatars/avatar-15.jpg",
  16: "assets/images/avatars/avatar-16.jpg",
  17: "assets/images/avatars/avatar-17.jpg",
  18: "assets/images/avatars/avatar-18.jpg",
  19: "assets/images/avatars/avatar-19.jpg",
  20: "assets/images/avatars/avatar-20.jpg",
  21: "assets/images/avatars/avatar-21.jpg",
  22: "assets/images/avatars/avatar-22.jpg",
  23: "assets/images/avatars/avatar-23.jpg",
  24: "assets/images/avatars/avatar-24.jpg",
  25: "assets/images/avatars/avatar-25.jpg",
  26: "assets/images/avatars/avatar-26.jpg",
  27: "assets/images/avatars/avatar-27.jpg",
  28: "assets/images/avatars/avatar-28.jpg",
  29: "assets/images/avatars/avatar-29.jpg",
  30: "assets/images/avatars/avatar-30.jpg",
  31: "assets/images/avatars/avatar-31.jpg",
  32: "assets/images/avatars/avatar-32.jpg",
  33: "assets/images/avatars/avatar-33.jpg",
  34: "assets/images/avatars/avatar-34.jpg",
  35: "assets/images/avatars/avatar-35.jpg",
  36: "assets/images/avatars/avatar-36.jpg",
  37: "assets/images/avatars/avatar-37.jpg",
  38: "assets/images/avatars/avatar-38.jpg",
  39: "assets/images/avatars/avatar-39.jpg",
  40: "assets/images/avatars/avatar-40.jpg",
  41: "assets/images/avatars/avatar-41.jpg",
  42: "assets/images/avatars/avatar-42.jpg",
  43: "assets/images/avatars/avatar-43.jpg",
  44: "assets/images/avatars/avatar-44.jpg",
  45: "assets/images/avatars/avatar-45.jpg",
  46: "assets/images/avatars/avatar-46.jpg",
  47: "assets/images/avatars/avatar-47.jpg",
  48: "assets/images/avatars/avatar-48.jpg",
  49: "assets/images/avatars/avatar-49.jpg",
  50: "assets/images/avatars/avatar-50.jpg",
};

export default avatars;
